module.exports = __webpack_public_path__ + "img/en.209843a9.png";